import { render, staticRenderFns } from "./target_fisik.vue?vue&type=template&id=3e0b0278&"
import script from "./target_fisik.vue?vue&type=script&lang=js&"
export * from "./target_fisik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QPagination,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
